package com.gastoncantera.intercom.push

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlin.js.Promise

/**
 * Obtiene el token FCM web. La obtención real (registro del service worker + `getToken` con la VAPID
 * key) la hace el shim JS `window.intercomGetFcmToken()` definido en `fcm.js`. Devuelve null si no
 * hay soporte, falta el shim o el usuario no dio permiso.
 */
actual suspend fun currentPushToken(): String? {
    val getter = window.asDynamic().intercomGetFcmToken ?: return null
    return try {
        val token = (getter() as Promise<String?>).await()
        if (token != null) PushTokenRegistry.update(token)
        token
    } catch (e: Throwable) {
        null
    }
}
